import _ from '@lodash';
import { AppBar, Checkbox, DialogActions, DialogContent, FormControl, FormControlLabel, Icon, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, TextField, Toolbar, Typography } from '@material-ui/core';
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import XAPPDialog from "app/Core/Components/Dialog/XAPPDialog";
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import clsx from 'clsx';
import MobileDetect from 'mobile-detect';
import React from 'react';
import { MdAdd, MdClose, MdLabel } from 'react-icons/md';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from '../Store/Actions/ComunicadorActions';

const md = new MobileDetect(window.navigator.userAgent);

class MensagemPermissao extends XAPPComponent {

    state = { menuEl: null, dialog: null };

    handleChangeMenu = (_AValue) => {
        this.setState(_.set({ ...this.state }, "menuEl", _AValue));
    };

    handleChangeGrupo = (_AGrupo) => {
        const { save, idmensagem } = this.props;
        save({ idmensagem: idmensagem, idgrupopermissao: _AGrupo.idgrupopermissao, idlocal: _AGrupo.idlocal }, "UPDATEGRUPOPERMISSAO");
    };

    isSelected = (_AValue) => {
        var { selected = null } = this.props;
        var AExists = false;
        !_.isNull(selected) && selected.forEach((id) => {
            if (id === _AValue.idgrupopermissao) {
                AExists = true;
            }
        });
        return AExists;
    }

    openDialog = (_AValue = null) => {
        this.setState(_.set({ ...this.state }, "dialog", _AValue));
    }

    handleChange = (ev) => {
        this.setState(_.set({ ...this.state }, ev.target.name, ev.target.value));
    }

    canBeSubmitted = () => {
        const { dialog } = this.state;
        return (!_.isUndefined(dialog?.nome) && !_.isNull(dialog?.nome) && dialog?.nome !== "")
    }

    render() {

        const { menuEl, dialog } = this.state;
        const { idmensagem, saveCustom, Grupos = [], idlocal, xappRouteParams, callback } = this.props;
        return (
            <React.Fragment>
                <XAPPButton
                    aria-owns={menuEl ? 'label-menu' : null}
                    aria-haspopup="true"
                    tooltip={{ "title": "Permissão", "placement": "top" }}
                    type="Icon"
                    className="text-16"
                    onClick={ev => {
                        ev.stopPropagation();
                        this.handleChangeMenu(ev.currentTarget);
                    }}
                    icon={"user_settings"}
                />
                <Menu
                    id="label-menu"
                    anchorEl={menuEl}
                    open={Boolean(menuEl)}
                    onClose={ev => {
                        ev.stopPropagation();
                        this.handleChangeMenu(null);
                    }}
                >
                    {!_.isNull(Grupos) && Grupos.map((grupo) => (
                        <MenuItem
                            onClick={ev => {
                                ev.stopPropagation();
                                this.handleChangeGrupo(grupo);
                            }}
                            key={"MenuItem_" + grupo.idgrupopermissao}
                        >
                            <ListItemIcon>
                                <Icon color="action">
                                    {this.isSelected(grupo) ? 'check_box' : 'check_box_outline_blank'}
                                </Icon>
                            </ListItemIcon>
                            <ListItemIcon className="m-0">
                                <MdLabel color="action" />
                            </ListItemIcon>
                            <ListItemText primary={grupo.nome} disableTypography={true} />
                        </MenuItem>
                    ))}
                    <MenuItem
                        onClick={ev => {
                            ev.stopPropagation();
                            this.openDialog({
                                idgrupopermissao: null,
                                nome: "",
                                idlocal: idlocal
                            });
                        }}
                        key={"MenuItem_NovoGrupo"}
                    >
                        <ListItemIcon>
                            <MdAdd color="action" size={20} />
                        </ListItemIcon>
                        <ListItemText primary={"Adicionar novo grupo"} disableTypography={true} />
                    </MenuItem>
                </Menu>
                <XAPPDialog
                    id="MensagemPermissao"
                    open={!_.isNull(dialog)}
                    onClose={() => this.openDialog()}
                    fullWidth
                    maxWidth="sm"
                >
                    <AppBar position="static" elevation={1}>
                        <Toolbar className="flex w-full min-h-0">
                            <Typography variant="subtitle1 text-white">
                                {!_.isNull(dialog) && !_.isNull(dialog.idgrupopermissao) ? "Editar grupo de permissão" : "Adicionar novo grupo de permissão"}
                            </Typography>
                            <div style={{ flex: 1 }} />
                            <IconButton
                                key="close"
                                aria-label="Close"
                                className="p-6"
                                onClick={() => this.openDialog()}
                            >
                                <MdClose className="text-20 text-white" />
                            </IconButton>
                        </Toolbar>
                    </AppBar>
                    <DialogContent className="p-20 overflow-hidden">
                        <div className="flex w-full xs:flex-wrap">
                            <TextField
                                className="w-full"
                                id={"dialog.nome"}
                                name={"dialog.nome"}
                                label={"Nome"}
                                value={dialog?.nome}
                                onChange={this.handleChange}
                                variant="outlined"
                                fullWidth
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                            <FormControl id={"readonly"} className={"items-start flex-col w-224 xs:w-full justify-center"}>
                                <FormControlLabel
                                    className={clsx("m-0 flex-row items-center")}
                                    control={
                                        <Checkbox
                                            className="px-8 py-4"
                                            name={"readonly"}
                                            type='checkbox'
                                            checked={dialog?.readonly === 1}
                                            onChange={ev => this.handleChange({ "target": { "name": "dialog.readonly", "value": dialog?.readonly === 1 ? 0 : 1 } })}
                                        />
                                    }
                                    label={<Typography className='text-start mr-16 text-16 whitespace-no-wrap'>{"Somente leitura"}</Typography>}
                                />
                            </FormControl>
                        </div>
                    </DialogContent>
                    <AppBar position="static" elevation={3} color="textSecondary">
                        <Toolbar className="flex w-full justify-end min-h-0 px-8">
                            <DialogActions>
                                <XAPPButton
                                    type="Button"
                                    className="bg-green hover:bg-green text-white mr-8"
                                    variant="contained"
                                    color="primary"
                                    onClick={() => {
                                        saveCustom({ ...dialog, idmensagem: idmensagem }, xappRouteParams, "INSERIRGRUPOPERMISSAO", callback);
                                        this.openDialog();
                                    }}
                                    disabled={!this.canBeSubmitted()}
                                    iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                    icon={"save"}
                                    label={md.mobile() === null && md.tablet() === null ? "Salvar" : ""}
                                />
                            </DialogActions>
                        </Toolbar>
                    </AppBar>
                </XAPPDialog>
            </React.Fragment>
        );
    }
}



function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        saveCustom: Actions.saveCustom,
    }, dispatch);
}

function mapStateToProps({ Comunicador, fuse }) {
    return {
        Comunicador: Comunicador,
        theme: fuse.settings.mainTheme
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MensagemPermissao);

